module.exports = __webpack_public_path__ + "media/images/web_suite/icon_tours-63b20d2f7b1bb2cd5c156398537c516e.png";